import Vue from "vue";
import BzbsApi from '@/service/BzbsApi.js';

export default {
    config: function () {
        return Vue.bzbsConfig;
    },
    apiGetConfig: function (url, fileName) {
        var fullURL = `${url}/${fileName}`;
        return BzbsApi.connectBzbsGetBlob(fullURL);
    }
}